import { render } from "./SpicyContainer.vue?vue&type=template&id=86f67520&scoped=true"
const script = {}

import "./SpicyContainer.vue?vue&type=style&index=0&id=86f67520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86f67520"]])

export default __exports__